import { isValidCpr, Region } from '@monthio/react-components'
import { ValidateCprFunction, ValidateCprAgainstServerFunction } from '../types'
import i18n from 'i18next'
import { getNationalIdentificationNumberErrorTranslation } from '../utils/getNationalIdentificationNumberErrorTranslation'

const validateIdentityNumber: ValidateCprFunction = async (
	cprNumber,
	validateCprAgainstServer: ValidateCprAgainstServerFunction,
) => {
	const nationalId = cprNumber
	if (!nationalId) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}

	const nationalIdRegEx = /^([0-9]{6})(-| |\+|)*([0-9]{5})$/
	const nationalIdMatch = nationalId?.match(nationalIdRegEx)
	const cleanedNationalId =
		(nationalIdMatch?.[1] ?? '') + (nationalIdMatch?.[3] ?? '')

	if (cleanedNationalId.length !== 11) {
		return {
			success: false,
			output: i18n.t(
				'no-consumerInputs-personalInformationValidation-personalNumberMustBe11Digits',
			),
		}
	}

	const validatedNationalId = isValidCpr(nationalId, { region: Region.Norway })

	if (!validatedNationalId.valid) {
		return {
			success: false,
			output: i18n.t(
				'no-consumerInputs-personalInformation-identityNumberInvalid-text',
			),
		}
	}

	const cprServerResponse = await validateCprAgainstServer(cleanedNationalId)

	if (!cprServerResponse.isValid) {
		return {
			success: false,
			output: getNationalIdentificationNumberErrorTranslation(
				cprServerResponse.error?.message,
			),
		}
	}

	return {
		success: true,
		output: nationalId,
	}
}

export default validateIdentityNumber
